import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapInterviewMethodOptions = (
  option: UCM.InterviewMethodOptionRawType,
): UCM.InterviewMethodOptionType => ({
  value: option.code,
  label: option.name,
});

const getInterviewMethodOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.InterviewMethodOptionRawType>
  >(API.GET.interviewMethodOptions, {
    headers: {
      Accept: 'application/vnd.falcon.v4+json',
    },
  });
  return data.data.map(({ attributes }) =>
    mapInterviewMethodOptions(attributes),
  );
};

export const useGetInterviewMethodOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.INTERVIEW_METHOD_OPTIONS],
    queryFn: getInterviewMethodOptions,
    staleTime: 1000 * 60 * 10,
    ...config,
  });
};
